// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMatchRouteContext from '../../hooks/useMatchRouteContext';
import useMergeProps from '../../hooks/useMergeProps';
import {
  makeBasketMatchSelectionsPredominantErrorIdSelector,
  makeMatchMMErrorIdSelector,
  selectMatchViewMode,
} from '../../selectors/match.selector';
import { MatchViewModes } from '../../types/matchView';

import MyMatchErrorPopUp from './MyMatchErrorPopUp';

type MyMatchErrorPopUpContainerProps = {
  className?: string;
};

const MyMatchErrorPopUpContainer = (ownProps: MyMatchErrorPopUpContainerProps) => {
  const { matchId } = useMatchRouteContext();
  const selectorProps = useMemo(() => ({ matchId }), [matchId]);

  const matchViewMode = useSelector((state) => selectMatchViewMode(state, selectorProps));

  const selectMatchMMErrorId = makeMatchMMErrorIdSelector();
  const _matchMMErrorId = useSelector((state) => selectMatchMMErrorId(state, selectorProps));
  const selectBasketMatchSelectionsPredominantErrorId = makeBasketMatchSelectionsPredominantErrorIdSelector();
  const basketSelectionPredominantErrorId = useSelector((state) =>
    selectBasketMatchSelectionsPredominantErrorId(state, selectorProps),
  );
  const matchMMErrorId = useMemo(
    () => _matchMMErrorId ?? basketSelectionPredominantErrorId,
    [_matchMMErrorId, basketSelectionPredominantErrorId],
  );
  const show = useMemo(
    () => matchViewMode === MatchViewModes.MY_MATCH && matchMMErrorId !== undefined,
    [matchMMErrorId, matchViewMode],
  );

  const selectedProps = useMemo(
    () => ({
      matchMMErrorId,
      show,
    }),
    [matchMMErrorId, show],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <MyMatchErrorPopUp {...enhancedProps} />;
};

export default MyMatchErrorPopUpContainer;
